// ASNDetailsTab.jsx
import React from "react";
import { asnDetailsFields } from "../formFields/asnTabsFields";
import GenericFormTab from "./GenericFormTab";

export default function ASNDetailsTab({ formData, onChange, formSubmissionAttempted }) {
  return (
    <GenericFormTab
      fields={asnDetailsFields}
      formData={formData}
      onChange={onChange}
      formSubmissionAttempted={formSubmissionAttempted}
    />
  );
}
